import { api } from './api';

// Campaign CRUD
export const createCampaign = (data) => api.post('/campaigns', data);
export const listCampaigns = (params = {}) => api.get('/campaigns', { params });
export const getCampaign = (id) => api.get(`/campaigns/${id}`);
export const updateCampaign = (id, data) => api.put(`/campaigns/${id}`, data);
export const deleteCampaign = (id) => api.delete(`/campaigns/${id}`);
export const updateCampaignStatus = (id, status) =>
  api.put(`/campaigns/${id}/status`, { status });

// Contact Management
export const uploadContactsFile = (campaignId, file, defaultRegion = 'MX') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('default_region', defaultRegion);
  return api.post(`/campaigns/${campaignId}/contacts/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const uploadContactsJson = (campaignId, contacts, defaultRegion = 'MX') => {
  const formData = new FormData();
  formData.append('contacts_json', JSON.stringify(contacts));
  formData.append('default_region', defaultRegion);
  return api.post(`/campaigns/${campaignId}/contacts/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const validateContactsFile = (file, defaultRegion = 'MX', campaignId = null) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('default_region', defaultRegion);
  // Pass campaign_id so the backend can fetch the tenant's column_mapping for
  // header remapping during the wizard Step 2 preview.
  if (campaignId) formData.append('campaign_id', campaignId);
  return api.post('/campaigns/contacts/validate', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const validateContactsJson = (contacts, defaultRegion = 'MX') => {
  const formData = new FormData();
  formData.append('contacts_json', JSON.stringify(contacts));
  formData.append('default_region', defaultRegion);
  return api.post('/campaigns/contacts/validate', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const listContacts = (campaignId, params = {}) =>
  api.get(`/campaigns/${campaignId}/contacts`, { params });

export const deleteContact = (campaignId, contactId) =>
  api.delete(`/campaigns/${campaignId}/contacts/${contactId}`);

export const listPhoneNumbers = () => api.get('/phone-numbers');

// Campaign call-log export (.xlsx)
export const exportCampaignCallLog = (campaignId, params = {}) =>
  api.get(`/campaigns/${campaignId}/call-log/export.xlsx`, {
    params,
    responseType: 'blob',
  });

// Webhook Integration
export const generateWebhookToken = (campaignId) =>
  api.post(`/campaigns/${campaignId}/webhook-token`);

export const fetchWebhookContacts = (campaignId, webhookUrl, defaultRegion = 'MX') =>
  api.post(`/campaigns/${campaignId}/fetch-webhook`, {
    webhook_url: webhookUrl,
    default_region: defaultRegion,
  });

// Field Descriptions (Data Dictionary)
export const updateFieldDescriptions = (campaignId, fieldDescriptions, fieldFormats = {}) =>
  api.put(`/campaigns/${campaignId}/field-descriptions`, {
    field_descriptions: fieldDescriptions,
    field_formats: fieldFormats,
  });

// Contact call data (transcript, summary, outcome)
export const getContactCallData = (campaignId, contactId) =>
  api.get(`/campaigns/${campaignId}/contacts/${contactId}/call-data`);

// Field Description Templates
export const listFieldTemplates = () => api.get('/field-templates');
export const createFieldTemplate = (name, fieldDescriptions, fieldFormats = {}) =>
  api.post('/field-templates', { name, field_descriptions: fieldDescriptions, field_formats: fieldFormats });
export const deleteFieldTemplate = (templateId) =>
  api.delete(`/field-templates/${templateId}`);

// Contact Labels & Notes
export const tagContact = (campaignId, contactId, labels, notes = '') =>
  api.put(`/campaigns/${campaignId}/contacts/${contactId}/tag`, { labels, notes });

// Manager Actions (retry, cancel, schedule_visit)
export const executeContactAction = (campaignId, contactId, action, note = '') =>
  api.post(`/campaigns/${campaignId}/contacts/${contactId}/action`, { action, note });

// Caller Assignment
export const assignCallers = (campaignId, callerIds) =>
  api.put(`/campaigns/${campaignId}/assign-callers`, { caller_ids: callerIds });

// Tenant outcome options (per analytics_layout)
export const getTenantOutcomeOptions = () => api.get('/tenants/me/outcome-options');
